import { Box, Typography } from "@mui/material"
import { UploadFileOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

const UploadFileLabel: FC<{
  label?: string
  onClick?: () => void
}> = ({ label, onClick }) => {
  return (
    <Box onClick={onClick} className='flex cursor-pointer items-center justify-center gap-2 text-blue-800'>
      <UploadFileOutlined fontSize='small' />
      <Typography variant='caption' className='text-center text-base font-medium text-blue-800'>
        {label || "Upload Document"}
      </Typography>
    </Box>
  )
}

export default UploadFileLabel
